export const iconFontAwesomeCodingUserSecret = (
	<i className="fa-solid fa-user-secret"></i>
);
